/**
 * The portal's React Query prefix.
 *
 * Its own key rather than a share of `PLANNING_KEY`: the two caches are read by different people on
 * different screens, and invalidating the team's project list because a customer refreshed their
 * own order would be work nobody asked for. Declared in a leaf file for the reason
 * `planningKeys.ts` gives — a key beside its hooks becomes an import cycle the moment a second
 * module wants it.
 */
export const PORTAL_KEY = 'portal';
